<div class="dialogo">
  <h1 mat-dialog-title class="titulo">
    Eliminar {{ this.data.tipo | lowercase }}
  </h1>
  <div mat-dialog-content>
    <p *ngIf="!finalizado">
      {{ "Seguro que desea eliminar el " + (this.data.tipo | lowercase) }}
    </p>
    <p *ngIf="!finalizado">{{ '"' + data.descripcion + '"' + "?" }}</p>
    <div style="padding-bottom: 5px; padding-top: 5px" *ngIf="error">
      <span class="error">{{ mensaje }}</span>
    </div>
    <div
      class="mensajeExitoso"
      style="padding-bottom: 15px; padding-top: 15px"
      *ngIf="finalizado"
    >
      <span
        ><mat-icon mat-list-icon class="waiting">warning</mat-icon> El
        {{ this.data.tipo | lowercase }}
        <b>{{ '"' + data.descripcion + '"' }}</b> fue eliminado
        correctamente</span
      >
    </div>
  </div>
  <div mat-dialog-actions>
    <span class="padding-right-10" *ngIf="!finalizado">
      <button
        mat-raised-button
        (click)="deleteMenu()"
        color="warn"
        style="padding-bottom: 5px; padding-top: 5px; margin-right: 10px"
        cdkFocusInitial
      >
        Eliminar
        <mat-icon>delete</mat-icon>
      </button>
    </span>

    <span class="padding-right-10" *ngIf="!finalizado">
      <button
        mat-raised-button
        style="padding-bottom: 5px; padding-top: 5px"
        (click)="cancelar()"
      >
        Cancelar
        <mat-icon>cancel</mat-icon>
      </button>
    </span>
    <span class="padding-right-10" *ngIf="finalizado">
      <button
        color="primary"
        mat-raised-button
        [mat-dialog-close]="true"
        style="padding-bottom: 5px; padding-top: 5px"
        (click)="aceptar()"
      >
        Aceptar
      </button>
    </span>
  </div>
</div>
